import { type ReactNode } from "react";
import { Controller, useFormContext, type FieldPath } from "react-hook-form";

import { Box } from "ui/box";
import { FieldLabel } from "ui/forms";
import { ToggleButtonGroup } from "ui/toggle-button-group";

import type { EmailConfigurationFormValues } from "containers/admin/clients/client/theme-configuration-page/configuration/email-configuration/email-configuration.types";

import {
  FIELD_GROUP_SX,
  FULL_WIDTH_SX,
} from "containers/admin/clients/client/theme-configuration-page/configuration/email-configuration/email-configuration.styles";

type AlignmentFieldProps = {
  name: FieldPath<EmailConfigurationFormValues>;
  options: { label: ReactNode; value: string }[];
  disabled: boolean;
};

export const AlignmentField = ({ name, options, disabled }: AlignmentFieldProps) => {
  const { control } = useFormContext<EmailConfigurationFormValues>();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Box sx={FIELD_GROUP_SX}>
          <FieldLabel name={name}>Alignment</FieldLabel>
          <ToggleButtonGroup
            groupName={`${name} alignment`}
            options={options}
            value={String(field.value)}
            onChange={field.onChange}
            size="sm"
            disabled={disabled}
            sx={FULL_WIDTH_SX}
          />
        </Box>
      )}
    />
  );
};
